import { useState, useEffect, useContext } from 'react';
import { formatDate, notify } from '../utils/utils';
import { AuthFetch } from '../services/api';
import { useModal } from './useModal';
import { UserContext } from '../context/provider/UserProvider';

export const useSugerencias = () => {
    const { stateUser } = useContext(UserContext);
    const [ sugerencia, setSugerencia ] = useState([]);
    const sugerenciaDefault = [
        {
            codUsuarioSugerenciaComentario: 1,
            comentario: 'A',
            uidCreacion: '',
            fechaHoraCreacion: '',
            numReaccionLike:0,
            numReaccionDislike:0,
        },
        {
            codUsuarioSugerenciaComentario: 1,
            comentario: 'B',
            uidCreacion: '',
            fechaHoraCreacion: '',
            numReaccionLike:0,
            numReaccionDislike:0,
        },
        {
            codUsuarioSugerenciaComentario: 1,
            comentario: 'C',
            uidCreacion: '',
            fechaHoraCreacion: '',
            numReaccionLike:0,
            numReaccionDislike:0,
        },
    ]
    const comentarioSugerenciaDefault = {
        uidAccion: stateUser.codUsuario,
        codUsuarioSugerencia: 0,
        motivo: ""
    }

    const quejaDefault = {
        uidAtencion: '',
        codSugerencia: 0,
        comentarioAtencion: '',
    }
    const [ sugerencias, setSugerencias ] = useState([]);
    const [ sugerenciasAC, setSugerenciasAC ] = useState([]);
    const [ sugerenciaAC, setSugerenciaAC ] = useState(sugerenciaDefault);
    const [ comentarioSugerencia, setComentarioSugerencia ] = useState(comentarioSugerenciaDefault);
    const [ isOpenModalDetalle, openModalDetalle, closeModalDetalle ] = useModal(false);
    const [ isOpenModalEliminar, openModalEliminar, closeModalEliminar ] = useModal(false);
    const [ quejas , setQuejas ] = useState([]);
    const [ queja, setQueja ] = useState(quejaDefault)
    // useEffect(() => {
    //     listarSugerencia();
    // }, []);

    const listarSugerencia = async () => {
        try{
            const response = await AuthFetch('/Claim/suggestions');
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setSugerencias(response.isValid ? response.content : []);
        }
        catch(error){
            setSugerencia([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const listarSugerenciaPorAplicativo = async (FechaInicio,FechaFin) => {
        try{
            const response = await AuthFetch('/Suggestion/allSuggestions?' + new URLSearchParams({
                fechaInicio: formatDate(FechaInicio, 23),
                fechaFin: formatDate(FechaFin, 23) 
            }))
            !response.isValid && notify(response.exceptions[0].description,'error');
            setSugerenciasAC(response.isValid ? response.content : []);
        }
        catch(error){
            setSugerenciasAC([]);
            notify('Ocurrió un error en el servicio','error');
        }
    }

    const obtenerDetalleSugerencia = async (codUsuarioSugerencia) => {
        try{
            const response = await AuthFetch('/Suggestion/allCommentSuggestion?' + new URLSearchParams({
                CodUsuarioSugerencia: codUsuarioSugerencia
            }));
            if(response.isValid){
                setSugerenciaAC(response.content)
            }
            else{
                notify(response.exceptions[0].description,'error')
                setSugerenciaAC(sugerenciaDefault)
            }
        }
        catch(error){
            setSugerenciaAC([]);
            notify('Ocurrió un error en el servicio', 'error');
        }

    }

    const eliminarComentarioSugerencia = async (identificador) => {
        try{
            const response = await AuthFetch(`/Suggestion/${identificador === 1 ? 'nullifySuggestion' : 'nullifyComment'}`,{
                method: 'PUT',
                body: JSON.stringify({
                    uidAccion: stateUser.codUsuario,
                    ...(identificador === 1 ? 
                            { codUsuarioSugerencia: comentarioSugerencia.codUsuarioSugerencia}
                        :
                            {codUsuarioSugerenciaComentario: comentarioSugerencia.codUsuarioSugerencia}
                    ),
                    motivo: comentarioSugerencia.motivo,
                })
            });
                notify(response.isValid ?  response.content : response.exceptions[0].description,response.isValid ? 'success' : 'error')
            return response.isValid
        }
        catch(error){
            notify('Ocurrió un error en el servicio','error');
            return false
        }
    }

    const editarValorSugerencia = (key, value) => {
        setComentarioSugerencia( comentario => {
            return{
                ...comentario,
                [key]: value 
            }
        })
    }

    const listarQuejas = async () => {
        try{
            const response = await AuthFetch('/Suggestion/complaint');
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setQuejas(response.isValid ? response.content : []);
        }
        catch(error){
            setQuejas([]);
            notify('Ocurrió un error en el servicio', 'error');
        }
    }

    const editarValorQueja = (key, value) => {
        setQueja( queja => {
            return{
                ...queja,
                [key]: value 
            }
        })
    }

    const atenderQueja = async () => {
        try{
            const response = await AuthFetch('/Suggestion/complaint',{
                method: 'PUT',
                body: JSON.stringify({
                    UIDAtencion: stateUser.codUsuario,
                    CodSugerencia: queja.codSugerencia,
                    Comentario: queja.comentarioAtencion,
                })
            })
            notify(response.isValid ?  response.content : response.exceptions[0].description,response.isValid ? 'success' : 'error')
            return response.isValid
        }
        catch(error){
            notify('Ocurrió un error en el servicio', 'error');
            return false
        }
    }
    
    return { 
        sugerencias ,
        listarSugerencia,
        listarSugerenciaPorAplicativo,
        sugerenciaAC,
        obtenerDetalleSugerencia,
        isOpenModalDetalle,
        openModalDetalle,
        closeModalDetalle,
        eliminarComentarioSugerencia,
        editarValorSugerencia,
        comentarioSugerencia,
        isOpenModalEliminar,
        openModalEliminar,
        closeModalEliminar,
        sugerenciasAC,
        listarQuejas,
        quejas,
        editarValorQueja,
        queja,
        atenderQueja
    }
}